import MessagingShared from "../../components/MessagingShared";
export default function ProfesorMensajeria() {
    return <MessagingShared allowedRoles={["padre", "psicologo", "administrativo"]} />;
}
